import type { TenantConfig } from '@core/domain/TenantContext.ts';

/** Sets tenant theme CSS variables on `document.documentElement`. */
export function applyTenantCssVariables(theme: TenantConfig['theme']): void {
  if (typeof document === 'undefined') return;
  const el = document.documentElement.style;
  el.setProperty('--color-primary', theme.primaryColor);
  el.setProperty('--color-secondary', theme.secondaryColor);
}
